export default "This view shows information on your inbound calls.\n\nA recap chart provides aggregated data, then a table displays detailed CDR data\n";